import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isMobile
    ? _c("CoreDialog", {
        attrs: {
          title: _vm.$t("Специалист", _vm.optionsLang),
          "data-qa": "lpu-speciality-list-modal",
          size: "fullscreen",
          transition: "fade-transition",
          divider: "",
          persistent: "",
          "hide-overlay": "",
          "no-click-animation": "",
        },
        scopedSlots: _vm._u(
          [
            {
              key: "prependBtn",
              fn: function ({ btnProps }) {
                return [
                  _c(
                    VBtn,
                    _vm._b(
                      { on: { click: _vm.handleCloseModal } },
                      "v-btn",
                      btnProps,
                      false
                    ),
                    [_c("span", { staticClass: "ui-icon-close-not-a-circle" })]
                  ),
                ]
              },
            },
            {
              key: "default",
              fn: function ({ counterXSpaceClass, xSpaceClass }) {
                return [
                  _c("LpuSpecialityListOptions", {
                    class: counterXSpaceClass,
                    attrs: {
                      options: _vm.options,
                      "x-space-class": xSpaceClass,
                    },
                    on: {
                      "lpu-select-speciality:select-option":
                        _vm.handleClickOption,
                    },
                  }),
                ]
              },
            },
          ],
          null,
          false,
          1544829402
        ),
        model: {
          value: _vm.isOpened,
          callback: function ($$v) {
            _vm.isOpened = $$v
          },
          expression: "isOpened",
        },
      })
    : _c(
        "SideMenu",
        {
          attrs: {
            value: _vm.isOpened,
            title: _vm.$t("Специалист", _vm.optionsLang),
            "side-menu-width": "650px",
            "side-menu-auto-scroll-y": "",
            "side-menu-is-block": "",
            "use-limit-title": "",
          },
          on: { "side-menu:click-close": _vm.handleCloseModal },
        },
        [
          _c("LpuSpecialityListOptions", {
            staticClass: "py-2",
            attrs: { options: _vm.options },
            on: {
              "lpu-select-speciality:select-option": _vm.handleClickOption,
            },
          }),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }